import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React from 'react';
// import { postFormDataAPI } from 'src/utils/api';

import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import * as pdfjsLib from 'pdfjs-dist';
import 'pdfjs-dist/build/pdf.worker.entry';
import BulkUploadPdf from 'src/components/common/bulkUpload/BulkUploadPdf';
pdfjsLib.GlobalWorkerOptions.workerSrc =
  '//cdnjs.cloudflare.com/ajax/libs/pdf.js/3.0.279/pdf.worker.min.js';

interface UploadPdfProps {
  open: boolean;
  onClose: () => void;
  patient: any;
}

const UploadPdf: React.FC<UploadPdfProps> = (props) => {

  const handleClose = () => {
    props.onClose();
  };

  return (
    <Dialog
      open={props.open}
      onClose={handleClose}
      //   slotProps={{ backdrop: { invisible: true } }}
      sx={{
        '& .MuiDialog-paper': {
          m: '0px !important',
          width: '600px',
          maxHeight: '90vh',
          bgcolor: '#FAFDFF',
        },
      }}
    >
      <DialogTitle id='scroll-dialog-title' sx={{ p: '24px 24px 0' }}>
        <Stack direction={'row'} justifyContent={'space-between'}>
          <Typography fontSize={'20px'} fontWeight={500}>
            文書ファイルアップロード
          </Typography>
          <IconButton
            aria-label='toggle password visibility'
            edge='end'
            onClick={handleClose}
          >
            <Box
              component={'img'}
              src='/images/ic-close-blue.svg'
              alt='icon eye'
              sx={{ width: '24px', height: '24px' }}
            />
          </IconButton>
        </Stack>
      </DialogTitle>

      <DialogContent
        sx={{
          p: '0px 24px 24px',
        }}
      >
        <BulkUploadPdf handleClose={handleClose} columnMd={3} allFile={false} patient={props.patient}/>
      </DialogContent>
    </Dialog>
  );
};

export default UploadPdf;
